<script setup lang="ts">
  import { Button } from "@/components/ui/button";
  import AiStar from "@/components/episto-ui/ai/AiStar.vue";

  defineProps({
    // idle · working (a turn is running) · done (an answer landed while closed)
    state: { type: String, default: "idle" },
    open: { type: Boolean, default: false },
  });

  defineEmits(["click"]);
</script>

<template>
  <Button
    type="button"
    variant="outline"
    class="relative isolate"
    :class="
      state === 'working'
        ? 'overflow-hidden border-transparent! before:absolute before:-inset-[60%] before:-z-2 before:animate-ai-spin before:rounded-full before:bg-[conic-gradient(from_0deg,transparent_0_55%,var(--color-ai-a)_78%,var(--color-ai-b)_100%)] before:content-[\'\'] before:motion-reduce:animate-none after:absolute after:-z-1 after:inset-[1.5px] after:rounded-[inherit] after:bg-background after:content-[\'\']'
        : ''
    "
    title="Episto AI (⌘J)"
    @click="$emit('click')">
    <AiStar class="size-5 text-ai-text" />
    <span>{{ state === "working" ? "Working…" : "Episto AI" }}</span>
    <kbd class="rounded border border-border px-1 font-mono text-3xs font-normal text-muted-foreground">⌘J</kbd>
    <span
      v-if="state === 'done' && !open"
      class="absolute -right-0.5 -top-0.5 size-2.5 animate-ai-pop rounded-full bg-ai-a ring-2 ring-background motion-reduce:animate-none" />
  </Button>
</template>
